<template>
  <div
    class="criteria-checklist"
    @click.stop
  >
    <div v-if="options">
      <div
        class="no-options-label"
        v-if="!hasOptions"
        v-text="$t('DocumentGrid.noOptionsAvailable')"
      />

      <div v-if="hasOptions">
        <ul
          class="criteria-list"
          :style="{
            'max-height': maxHeight
          }"
        >
          <li
            class="criteria-list-item"
            v-for="(option, key) in options"
            :key="key"
            @click="selectPageCount(option)"
          >
            <label
              v-text="option.Value"
              :title="option.Value"
              v-bind:class="{ 'criteria-list-item-selected' : option.Selected }"
            />
          </li>
        </ul>
      </div>
    </div>

    <spinner
      v-else
      :message="$t('DocumentGrid.searchingFilters')"
    />
  </div>
</template>

<script>
import * as _ from 'lodash'

import Spinner from '../../../Spinner.vue'

export default {
  name: 'CriteriaCheckList',
  components: {
    'spinner': Spinner
  },
  data () {
    return {
    }
  },
  created () {
  },
  props: {
    maxHeight: {
      default: '270px',
      type: String
    },
    currentOptions: {
      default: function () {
        return []
      },
      type: Array
    }
  },
  computed: {
    hasOptions () {
      let self = this
      return _.size(self.currentOptions) > 0
    },
    options () {
      return this.currentOptions
    }
  },
  methods: {
    selectPageCount (option) {
      this.currentOptions.forEach(item => {
        item.Selected = false
      })
      option.Selected = true
      this.$emit('setItemsPerPage', option.Value)
    }
  }
}
</script>

<style lang="scss" scoped>
  /*@import "~ui.kit.styling";*/
  @import '../../../../kit-components/uikit';
  @import '../../../../kit-components/styling/definitions';

  .criteria-checklist {
    cursor: default;
    min-width: 100px;
    background: white;
    top: 5px;
    z-index: 10;
    position: relative;
    box-shadow: $primaryBoxShadow;
    min-height: 30px;

    .no-options-label {
      font-style: italic;
      font-weight: normal;
      font-size: 13px;
      color: $lightGreyFont;
      width: 100%;
      text-align: center;
      margin: 7px;
    }

    .criteria-list {
      width: 100%;
      padding: 5px;
      margin: 0;
      list-style: none;
      overflow-y: auto;

      &-item {
        cursor: pointer;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: 400;
        font-size: 13px;
        list-style: none;
        margin: 0;
        padding: 6px;

        label {
          cursor: inherit;
          color: $mediumGreyFont;
          display: block;
          text-indent: 10px;
        }

        &:hover {
          background-color: $lightGreyBackground;

          label {
            color: $darkGreyFont;
          }
        }

        &-selected {
          color: blueviolet !important;
        }
      }
    }

    .apply-button {
      height: 25px;
      border: 1px solid $primaryBorderColor;
      border-radius: 2px;
      background: #fff;
      font-size: 13px;
      color: $mediumGreyFont;
      width: calc(100% - 20px);
      margin: 5px 10px 10px 10px;

      &:hover {
        background: $mediumGreyBackground;
        border-color: $disabledBorderColor;
      }
    }
  }
  #facetFilter {
    height: 25px;
    border: 1px solid $primaryBorderColor;
    border-radius: 2px;
    background: #fff;
    font-size: 13px;
    color: $mediumGreyFont;
    width: calc(100% - 20px);
    margin: 5px 5px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/grid/Criteria/content/CriteriaOptionList.vue